<template>
  <v-row justify="center">
    <v-dialog v-model="menu" persistent max-width="600px">
      <template v-slot:activator="{ on, attrs }">
        <v-list-item v-bind="attrs" v-on="on">
          <v-list-item-content>
            <v-list-item-title> {{ tipo }} </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-card v-if="tipo === 'Educação Infantil'">
        <v-card-title>
          <span class="text-h5">{{ tipo }}</span>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item @click="gerarAtaFinalInfantil(gestao.turma_id)">
              <v-list-item-icon>
                <v-icon small>visibility</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Ata Final da Turma - {{ tipo }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              :to="{
                name: 'relatorios.visualizar',
                params: {
                  turmaId: gestao.turma_id,
                  gestaoDeAulasId: gestao.id,
                },
              }"
            >
              <v-list-item-icon>
                <v-icon small>visibility</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Lançar Notas - Infantil</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="verAulasInfantil(gestao.id)">
              <v-list-item-icon>
                <v-icon small>visibility</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <!-- <v-list-item-title> <a :href="`gestoes-de-aulas/${gestao.id}/aulas?infantil=true`">Aulas</a>  </v-list-item-title> -->
                <v-list-item-title>Aulas</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="gestao.is_polivalencia === 1"
              clickable
              @click="
                escolherDisciplina(gestao.id, gestao.disciplinas, 'planosBimestraisInfantilPoli')
              "
            >
              <v-list-item-icon>
                <v-icon small>fa fa-book</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Criar Plano Bimestral Infantil</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item
              v-else
              @click="
                $router.push({
                  name: 'gestoesDeAulas.planoBimestralInfantil',
                  params: {
                    gestaoDeAulaId: gestao.id,
                    disciplinaId: gestao.disciplinas,
                  },
                })
              "
            >
              <v-list-item-icon>
                <v-icon small>fa fa-book</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Criar Plano Bimestral Infantil</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- {{ (!gestao.estaDeletado && gestao.turma.multi) && (gestao.disciplina_id === 22 && gestao.is_polivalencia === 0) }} -->
            <v-list-item-group color="primary">
              <v-menu open-on-hover left offset-x>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item
                    v-if="
                      !gestao.estaDeletado &&
                      gestao.turma.multi &&
                      gestao.disciplina_id === 22 &&
                      gestao.is_polivalencia === 0
                    "
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-list-item-icon>
                      <v-icon small>fa fa-file-pdf</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Gerar plano bimestral infantil</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in $constants.bimestres" :key="index">
                    <v-list-item-title @click="gerarPlanoBimestralInfantil(gestao.id, item)">
                      {{ item.desc }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-group>

            <!-- <v-list-item
              v-else
              :to="{
                name: 'gestoesDeAulas.planoSemestralInfantil',
                params: { gestaoDeAulaId: gestao.id },
              }"
            >
              <v-list-item-icon>
                <v-icon small>fa fa-book</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Criar Plano Semestral Infantil</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <v-list-item-group color="primary" v-if="gestao.is_polivalencia === 1">
              <v-menu open-on-hover left offset-x>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-icon>
                      <v-icon small>fa fa-file-pdf</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Gerar plano bimestral infantil</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in $constants.bimestres" :key="index">
                    <v-list-item-title
                      @click="
                        escolherDisciplinaPDF(
                          gestao.id,
                          gestao.disciplinas,
                          'planosBimestraisInfantilPDF',
                          item
                        )
                      "
                    >
                      {{ item.desc }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-group>

            <v-list-item-group color="primary" v-if="gestao.is_polivalencia === 1">
              <v-menu open-on-hover left offset-x>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-icon>
                      <v-icon small>fa fa-file-pdf</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Gerar plano semestral infantil</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in $constants.semestres" :key="index">
                    <v-list-item-title
                      @click="
                        escolherDisciplinaPDF(
                          gestao.id,
                          gestao.disciplinas,
                          'planosSemestraisInfantilPoliPDF',
                          item
                        )
                      "
                    >
                      {{ item.desc }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-group>

            <v-list-item-group
              color="primary"
              v-if="
                !gestao.estaDeletado &&
                gestao.turma.multi &&
                gestao.disciplina_id === 22 &&
                gestao.is_polivalencia === 0
              "
            >
              <v-menu open-on-hover left offset-x>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-icon>
                      <v-icon small>fa fa-file-pdf</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Gerar plano semestral infantil</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in $constants.semestres" :key="index">
                    <v-list-item-title @click="gerarPlanoSemestralInfantil(gestao.id, item)">
                      {{ item.desc }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-group>

            <v-list-item
              :to="{
                name: 'gestoesDeAulas.metricasTurma',
                params: {
                  id: gestao.turma_id,
                  gestao: gestao.id,
                },
              }"
            >
              <v-list-item-icon>
                <v-icon small>mdi-file</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Métricas da turma </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="capaDiarioClasse(gestao.id)">
              <v-list-item-icon>
                <v-icon small>mdi-file</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Capa do Diário de Classe </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="menu = false"> Fechar </v-btn>
        </v-card-actions>

        <div v-if="dialogConfirmarAulas">
          <e-dialog-search-aulas-interval-date
            :gestao_selected_to_interval="gestao_selected_to_interval"
            :dialogConfirmarAulas="dialogConfirmarAulas"
            @dialogAulasChange="dialogConfirmarAulas = $event"
          >
          </e-dialog-search-aulas-interval-date>
        </div>
      </v-card>
      <v-card v-if="tipo === 'Ensino Fundamental'">
        <v-card-title>
          <span class="text-h5">{{ tipo }}</span>
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item @click="ataFinal(gestao.turma_id)">
              <v-list-item-icon>
                <v-icon small>mdi-file</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Ata Final da Turma - {{ tipo }} </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="gerarBoletimGeral(gestao.turma_id)">
              <v-list-item-icon>
                <v-icon small>mdi-file</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Boletim Geral da Turma - {{ tipo }} </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="verAulas(gestao.id)">
              <v-list-item-icon>
                <v-icon small>mdi-file</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Aulas </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="gestao.is_polivalencia"
              @click="escolherDisciplina(gestao.id, gestao.disciplinas, 'notas')"
            >
              <v-list-item-icon>
                <v-icon small>visibility</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Lançar Notas</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-else
              :to="{
                name: 'notas.circuitoNotas',
                params: {
                  gestaoDeAulasId: gestao.id,
                  disciplinaId: gestao.disciplina_id,
                },
              }"
            >
              <v-list-item-icon>
                <v-icon small>visibility</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Lançar Notas </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- <v-list-item
                @click="
                  if (gestao.is_polivalencia === 1) {
                    escolherDisciplina(gestao.id, gestao.disciplinas, 'planosMensais');
                  } else {
                    $router.push({
                      name: 'gestoesDeAulas.planoMensalCreate',
                      params: {
                        gestaoDeAulaId: gestao.id,
                        disciplinaId: gestao.disciplina_id,
                      },
                    });
                  }
                "
              >
                <v-list-item-icon>
                  <v-icon small>mdi-file</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title> Criar Plano Mensal</v-list-item-title>
                </v-list-item-content>
              </v-list-item> -->
            <!-- <v-list-item
              @click="
                if (gestao.is_polivalencia === 1) {
                  escolherDisciplina(gestao.id, gestao.disciplinas, 'planosSemestrais');
                } else {
                  $router.push({
                    name: 'gestoesDeAulas.planoSemestralCreate',
                    params: {
                      gestaoDeAulaId: gestao.id,
                      disciplinaId: gestao.disciplina_id,
                    },
                  });
                }
              "
            >
              <v-list-item-icon>
                <v-icon small>fa fa-book</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Criar Plano Semestral</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <v-list-item
              @click="
                if (gestao.is_polivalencia === 1) {
                  escolherDisciplina(gestao.id, gestao.disciplinas, 'planos');
                } else {
                  $router.push({
                    name: 'gestoesDeAulas.planoBimestralCreate',
                    params: {
                      gestaoDeAulaId: gestao.id,
                      disciplinaId: gestao.disciplina_id,
                    },
                  });
                }
              "
            >
              <v-list-item-icon>
                <v-icon small>fa fa-book</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Criar Plano Bimestral</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <!-- <v-list-item
                @click="
                  if (gestao.is_polivalencia === 1) {
                    escolherDisciplinaMes(gestao.id, gestao.disciplinas);
                  } else {
                    escolherDisciplinaPDF(gestao.id, gestao.disciplina_id, 'planosMensaisPDF');
                  }
                "
              >
                <v-list-item-icon>
                  <v-icon small>mdi-file</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title> Visualizar Plano Mensal </v-list-item-title>
                </v-list-item-content>
              </v-list-item> -->

            <v-list-item-group color="primary">
              <v-menu open-on-hover left offset-x>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-icon>
                      <v-icon small>fa fa-file-pdf</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Visualizar Plano Semestral </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in $constants.semestres" :key="index">
                    <v-list-item-title
                      v-if="gestao.is_polivalencia"
                      @click="
                        escolherDisciplinaPDF(
                          gestao.id,
                          gestao.disciplinas,
                          'planosSemestraisPDF',
                          item.value
                        )
                      "
                    >
                      {{ item.desc }}
                    </v-list-item-title>
                    <v-list-item-title v-else @click="gerarPlanoSemestral(gestao, item)">
                      {{ item.desc }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-group>

            <v-list-item-group color="primary">
              <v-menu open-on-hover left offset-x>
                <template v-slot:activator="{ on, attrs }">
                  <v-list-item v-bind="attrs" v-on="on">
                    <v-list-item-icon>
                      <v-icon small>fa fa-file-pdf</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title>Visualizar Plano Bimestral</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-list>
                  <v-list-item v-for="(item, index) in $constants.bimestres" :key="index">
                    <v-list-item-title
                      v-if="gestao.is_polivalencia"
                      @click="
                        escolherDisciplinaPDF(
                          gestao.id,
                          gestao.disciplinas,
                          'planosBimestraisPDF',
                          item.value
                        )
                      "
                    >
                      {{ item.desc }}
                    </v-list-item-title>
                    <v-list-item-title v-else @click="gerarPlanoBimestralFundamental(gestao, item)">
                      {{ item.desc }}
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item-group>

            <v-list-item
              :to="{
                name: 'gestoesDeAulas.metricasTurma',
                params: {
                  id: gestao.turma_id,
                  gestao: gestao.id,
                },
              }"
            >
              <v-list-item-icon>
                <v-icon small>mdi-file</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Métricas da turma </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="capaDiarioClasse(gestao.id)">
              <v-list-item-icon>
                <v-icon small>mdi-file</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title> Capa do Diário de Classe </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="menu = false"> Fechar </v-btn>
        </v-card-actions>

        <e-escolha-disciplina
          @status="abrirModalEscolha = $event"
          :dialog="abrirModalEscolha"
          :gestaoDeAulasId="gestaoDeAulasEscolhida"
          :disciplinas="disciplinasArray"
          :typeModel="typeModel"
        ></e-escolha-disciplina>

        <div v-if="dialogConfirmarAulas">
          <e-dialog-search-aulas-interval-date
            :gestao_selected_to_interval="gestao_selected_to_interval"
            :dialogConfirmarAulas="dialogConfirmarAulas"
            @dialogAulasChange="dialogConfirmarAulas = $event"
          >
          </e-dialog-search-aulas-interval-date>
        </div>

        <e-escolha-disciplina-mes
          @status="abrirModalEscolhaMes = $event"
          :dialog="abrirModalEscolhaMes"
          :gestaoDeAulasId="gestaoDeAulasEscolhida"
          :disciplinas="disciplinasArray"
          :typeModel="typeModel"
        ></e-escolha-disciplina-mes>
      </v-card>
    </v-dialog>
    <e-escolha-disciplina
      @status="abrirModalEscolha = $event"
      :dialog="abrirModalEscolha"
      :gestaoDeAulasId="gestaoDeAulasEscolhida"
      :disciplinas="disciplinasArray"
      :typeModel="typeModel"
    ></e-escolha-disciplina>
    <e-escolha-disciplina-mes-pdf
      @status="abrirModalEscolhaMesPDF = $event"
      :dialog="abrirModalEscolhaMesPDF"
      :gestaoDeAulasId="gestaoDeAulasEscolhida"
      :bimestre="bimestreEscolhido"
      :disciplinas="disciplinasArray"
      :typeModel="typeModel"
    ></e-escolha-disciplina-mes-pdf>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    bimestreEscolhido: null,
    tipoEnsino: "fundamental",
    abrirModalEscolhaMes: false,
    abrirModalEscolha: false,
    abrirModalEscolhaMesPDF: false,
    menu: false,
    disciplinasArray: [],
    gestaoDeAulasEscolhida: null,
    disciplinaEscolhida: null,
    abrirModalEscolhaPlanoBimestral: false,
    dialogConfirmarAulas: false,
    gestao_selected_to_interval: null,
    typeModel: null,
  }),

  props: {
    tipo: {
      type: String,
    },
    gestao: {
      type: Object,
    },
    turma: {
      type: Object,
    },
  },
  methods: {
    async gerarPlanoSemestralInfantil(gestaoId, item) {
      try {
        this.$loaderService.open("Gerando plano de aula...");
        const response = await this.$services.relatoriosService.planoSemestralInfantil(
          parseInt(gestaoId, 10),
          parseInt(item.value, 10)
        );
      } catch (error) {
        this.$handleError(error, "Erro ao gerar plano semestral");
      } finally {
        this.$loaderService.close();
      }
    },
    async gerarPlanoSemestral(gestaoDeAulas, item) {
      try {
        this.$loaderService.open("Gerando plano semestral.....");
        await this.$services.relatoriosService.planoSemestral(
          parseInt(gestaoDeAulas.id, 10),
          parseInt(item.value, 10),
          parseInt(gestaoDeAulas.disciplina_id, 10)
        );
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async gerarBoletimGeral(turmaId) {
      this.$loaderService.open("Carregando dados...");
      await this.$services.relatoriosService.boletimGeral(parseInt(turmaId, 10));
      this.$loaderService.close();
    },
    async gerarAtaFinalInfantil(turmaId) {
      try {
        this.$loaderService.open("Carregando dados...");
        await this.$services.relatoriosService.gerarAtaFinal(parseInt(turmaId, 10));
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
        this.$loaderService.close();
      }
    },

    async ataFinal(turmaId) {
      this.$loaderService.open("Carregando dados...");
      try {
        await this.$services.relatoriosService.resultadoPorDisciplina(parseInt(turmaId, 10));
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    async gerarPlanoBimestralInfantil(gestaoId, item) {
      try {
        this.$loaderService.open("Gerando plano de aula...");
        await this.$services.relatoriosService.planoBimestralInfantil(
          parseInt(gestaoId, 10),
          parseInt(item.value, 10)
        );
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async gerarPlanoBimestralFundamental(gestaoDeAulasId, item) {
      try {
        this.$loaderService.open("Gerando plano bimestral...");
        await this.$services.relatoriosService.planoBimestral(
          parseInt(gestaoDeAulasId.id, 10),
          parseInt(item.value, 10),
          parseInt(gestaoDeAulasId.disciplina_id, 10)
        );
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      }
    },
    verAulasInfantil(gestaoId) {
      // query: { search: 'vue', page: 1 }
      this.$router.push({
        name: "aulas",
        params: {
          gestaoDeAulaId: gestaoId,
        },
        query: { is_infantil_multi: "true" },
      });
    },
    escolherDisciplinaPDF(idGestao, disciplinas, type, bimestre) {
      this.abrirModalEscolhaMesPDF = true;
      this.disciplinasArray = disciplinas;
      this.gestaoDeAulasEscolhida = idGestao;
      this.bimestreEscolhido = bimestre;
      this.typeModel = type;
    },
    escolherDisciplina(idGestao, disciplinas, type) {
      if (!idGestao || !Array.isArray(disciplinas) || !type) return;
      this.abrirModalEscolha = true;
      this.disciplinasArray = disciplinas;
      this.gestaoDeAulasEscolhida = idGestao;
      this.typeModel = type;
    },

    escolherDisciplinaMes(idGestao, disciplinas, type) {
      this.abrirModalEscolhaMes = true;
      this.disciplinasArray = disciplinas;
      this.gestaoDeAulasEscolhida = idGestao;
      this.typeModel = type;
    },
    async capaDiarioClasse(gestaoId) {
      this.$loaderService.open("Gerando capa diario...");
      try {
        await this.$services.relatoriosService.capaDiarioClasse(parseInt(gestaoId, 10));
        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    escolherDisciplinaPlanoBimestral(gestaoDeAulasId, disciplinas) {
      this.abrirModalEscolhaPlanoBimestral = true;
      this.disciplinasArray = typeof disciplinas === "string" ? [disciplinas] : disciplinas;
      this.gestaoDeAulasEscolhida = gestaoDeAulasId;
    },

    async verAulas(gestaoDeAulaID) {
      this.$router.push({
        name: "aulas",
        params: {
          gestaoDeAulaId: gestaoDeAulaID,
        },
        query: { is_infantil_multi: "false" },
      });
    },

    async gerarRelatorio() {
      this.$loaderService.open("Carregando dados...");
      await this.$services.relatoriosService.listarTurma(parseInt(this.$route.params.turmaId, 10));
      this.$loaderService.close();
    },
  },
};
</script>
